
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.204 10.342c.752 0 1.408-.164 1.968-.492.56-.328-.056-1.216-.504-.96a2.9 2.9 0 01-1.464.384c-.616 0-1.162-.16-1.638-.48a2.725 2.725 0 01-1.038-1.332h2.22a.456.456 0 100-.912H4.312l-.024-.504.024-.504h2.436a.456.456 0 100-.912h-2.22a2.725 2.725 0 011.038-1.332 2.867 2.867 0 011.638-.48c.456 0 .876.108 1.26.324.384.216 1.04-.572.528-.9-.512-.328-1.108-.492-1.788-.492-.904 0-1.704.26-2.4.78s-1.176 1.22-1.44 2.1h-.708a.456.456 0 100 .912h.528l-.024.504.024.504h-.528a.456.456 0 100 .912h.708c.264.88.744 1.58 1.44 2.1s1.496.78 2.4.78z"}})])
          )
        }
      }
    